<template>
  <div class="section">
    <div class="subscribe">
      <div class="max-width">
        <div class="subscribe__grid">
          <div class="subscribe__about">
            <div class="subscribe__title">Be the First to&nbsp;Know</div>
            <div class="subscribe__desc">New theme releases, performance updates, store growth guides, and curated industry resources — delivered to your inbox before everyone else.</div>

            <SubformView :theme="theme" :id="id"/>
          </div>

          <div class="subscribe__image">
            <img loading="lazy" srcset="/assets/imgs/themes/zap/subscribe.webp 1x, /assets/imgs/themes/zap/subscribe@2x.webp 2x" src="/assets/imgs/themes/zap/subscribe.webp">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrow from '@/components/icons/IconArrow.vue'
import SubformView from '@/components/SubformView.vue'

export default {
  name: 'SubscribeView',
  components: { IconArrow, SubformView },
  props: {
    subheading: { type: String, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
    theme: { type: String, default: '' },
    id: { type: Number, default: 0 }
  }
}
</script>

<style lang="scss">
.subscribe {
  background:#07071C;
  color:#fff;
  padding:4.5rem 0;

  @include md {
    padding:3rem 0;
  }

  &__grid {
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:3rem;

    @include md {
      flex-direction:column-reverse;
      gap:2rem;
    }
  }

  &__about {
    flex:auto;
    max-width:530px;
  }

  &__title {
    margin:0 0 1rem;
    letter-spacing: -0.02em;
    text-transform: uppercase;
    font-size:3rem;
    color:#fff;
    font-weight:900;
    line-height:.9;

    @include md {
      font-size:2rem;
    }
  }

  &__desc {
    margin:0 0 1.5rem;
    opacity:.7;
    color:#fff;
    font-size:1rem;
    max-width:420px;
  }

  &__image {
    flex:none;
    width:55.5%;

    @include md {
      width:100%;
    }
  }
}
</style>
